import { DateTime } from "luxon";

import { IBFRecordParsingDefinition } from "@/lib/drivers/insulet/IBFRecords/RecordParser";

type IBFLogHeader = {
  logsInfoRevision: number;
  insulinHistoryRevision: number;
  alarmHistoryRevision: number;
  bloodGlucoseRevision: number;
  insuletStatsRevision: number;
  date: DateTime;
  numLogDescriptions: number;
  logDescriptions: IBFLogDescription[];
};

export const IBF_LOG_HEADER = {
  // Value is just the order in which the items are present in the file
  value: 7,
  name: "IBF_LOG_HEADER",
  size: 15,
  parse: record => {
    const logsInfoRevision = record.nextUInt8();
    const insulinHistoryRevision = record.nextUInt8();
    const alarmHistoryRevision = record.nextUInt8();
    const bloodGlucoseRevision = record.nextUInt8();
    const insuletStatsRevision = record.nextUInt8();
    const date = record.nextDateTime();
    record.skip(1);
    const numLogDescriptions = record.nextUInt16BE();
    const logDescriptions: IBFLogDescription[] = [];
    for (let i = 0; i < numLogDescriptions; i++) {
      const logDescription = IBF_LOG_DESCRIPTION.parse(record);
      logDescriptions.push(logDescription);
    }
    return {
      logsInfoRevision,
      insulinHistoryRevision,
      alarmHistoryRevision,
      bloodGlucoseRevision,
      insuletStatsRevision,
      date,
      numLogDescriptions,
      logDescriptions,
    };
  },
} satisfies IBFRecordParsingDefinition<IBFLogHeader>;

type IBFLogDescription = {
  logIndex: number;
  backup: number;
  location: number;
  hasVariableLength: number;
  recordSize: number;
  firstIndex: number;
  lastIndex: number;
  numRecords: number;
};

export const IBF_LOG_DESCRIPTION = {
  value: 1,
  name: "IBF_LOG_DESCRIPTION",
  size: 18,
  parse: record => {
    const logIndex = record.nextUInt16BE();
    const backup = record.nextUInt16BE();
    const location = record.nextUInt16BE();
    const hasVariableLength = record.nextUInt16BE();
    const recordSize = record.nextUInt16BE();
    const firstIndex = record.nextInt32BE();
    const lastIndex = record.nextInt32BE();
    const numRecords = lastIndex - firstIndex + 1;
    return {
      logIndex,
      backup,
      location,
      hasVariableLength,
      recordSize,
      firstIndex,
      lastIndex,
      numRecords,
    };
  },
} satisfies IBFRecordParsingDefinition<IBFLogDescription>;
